import { apiFetch } from '~/shared/api/api-fetch';
import { CurrentEmployeeDtoSchema } from '~/modules/employees/api/dto/employees.dto';

/** Получение информации о текущем юзере как сотруднике */
export function fetchCurrentEmployee() {
  return apiFetch('/ui/v1/employee/current', {
    schema: CurrentEmployeeDtoSchema,
  });
}
